import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { SectionProps } from "../../utils/SectionProps";
import Header from "../layout/Header";
import ButtonGroup from "../elements/ButtonGroup";
import Button from "../elements/Button";
import { useLocation, Link } from "react-router-dom";
import queryString from "query-string";
import AwesomeSlider from "react-awesome-slider";
import withAutoplay from "react-awesome-slider/dist/autoplay";
import "react-awesome-slider/dist/styles.css";
import AuthApi from "../services/authApi";
import AuthApi1 from "../services/authApi";
import authApi2 from "../services/authApi";
import Loader from "react-js-loader";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import moment from "moment";
import info from "../../assets/images/info.png";
// import makeStyles from "@emotion/styled";
import useMediaQuery from "@mui/material/useMediaQuery"; 
import gpayLogo from '../../assets/images/1.png'; // Adjust path as needed
import phone_payLogo from '../../assets/images/2.png'; // Adjust path as needed
import anyUPILogo  from '../../assets/images/3.png'; // Adjust path as needed
import addch_logo  from '../../assets/images/7.png'; // Adjust path as needed
import comp_logo  from '../../assets/images/4.png'; // Adjust path as needed
import tran_logo  from '../../assets/images/5.png'; // Adjust path as needed
import ot_logo  from '../../assets/images/6.png'; // Adjust path as needed

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography,
  Divider,
} from "@mui/material";
import "./MoveText.css";
import swal from "sweetalert";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleUser,
  faDisplay,
  faIdCardClip,
  faReceipt,
  faCalendarDay,
  faCircleInfo,
  faLaptopHouse,
  faHeartPulse,
} from "@fortawesome/free-solid-svg-icons";
import { toInteger } from "lodash";
import axios from "axios";

const AutoplaySlider = withAutoplay(AwesomeSlider);

const propTypes = {
  ...SectionProps.types,
};

const defaultProps = {
  ...SectionProps.defaults,
};

const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {
 // const { search } = useLocation();
 
 const location = useLocation();
  var [isLoading, setLoading] = useState(true);
  //const { custV } = queryString.parse(search);
  //const { custNumber } = queryString.parse(search);
  const search = window.location.search || ''; // Ensure `search` is a string

  // Safely parse the query string
  const { custV = '', custNumber = '' } = queryString.parse(search);
  const [custVc, setCustV] = useState(null);

  var [isButtonLoading, setButtonLoading] = useState(false);

  var [isflagSTB,setisFlagSTB]=useState("");
  const { base64encode, base64decode } = require("nodejs-base64");

  // let encoded = base64encode(custNumber);
  const outerClasses = classNames(
    "hero section center-content",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  useEffect(() => {
    //razorflag();
   let sess_value= localStorage.getItem("custNumbervalue")
    localStorage.clear();
    localStorage.setItem("custNumbervalue",sess_value);
    getDetailsCust().then(() => {
      fetchAdBanner();
    });
  }, []);

  const getpackdetails = async (
    Merchant_Salt,
    AGREEMENT_NO,
    owner_id,
    cust_num,
    MSO_ID
  ) => {
    let userData = {
      lcousername: Merchant_Salt,
      nxt_id: AGREEMENT_NO,
      owner_id: owner_id,
      cust_num: cust_num,
      MSO: MSO_ID,
    }; //
    setLoading(false);
    isLoading = false;
  };

  // const getDetails = async () => {
  //   isLoading = true;

  //   let decoded = base64decode(custNumber);
  //   let userData = {
  //     CUST_NUM: decoded,
  //     FLAG: "B",
  //   };
  //   await AuthApi1.getdetail(userData)
  //     .then((response) => {
  //       let data = response.data.customerInfo;
  //       let newDateFormat = moment(data.PRE_END_DATE, 'YYYY-MM-DD').format('DD-MMMM-YYYY');
  //       localStorage.setItem("custNum", data.cust_num);
  //       localStorage.setItem("custID", data.CUSTOMER_ID);
  //       localStorage.setItem("phone", data.Phone);
  //       localStorage.setItem("custName", data.name);
  //       localStorage.setItem("email", data.EMAIL);
  //       localStorage.setItem("stbNumber", data.stb);
  //       localStorage.setItem("op_email", data.OP_Email_Id);
  //       localStorage.setItem("op_phone", data.Contact_Number);
  //       localStorage.setItem("dueAmount", data.bill_total);
  //       localStorage.setItem("bill_total", data.total_pay);
  //       localStorage.setItem("advn_dep_amnt",data.cust_advn_dep_amnt);
  //       localStorage.setItem("packTotal",data.L_PACK_TOTAL_AMOUNT);
  //       localStorage.setItem("cust_due",data.cust_due_amnt);
  //       localStorage.setItem("operatorId", data.operator_id);
  //       localStorage.setItem("operatorName", data.operator_comp_name);
  //       localStorage.setItem("Merchant_Salt", data.Merchant_Salt);
  //       localStorage.setItem("AGREEMENT_NO", data.AGREEMENT_NO);
  //       localStorage.setItem("PRE_END_DATE", newDateFormat);
  //       localStorage.setItem("rem_days", data.rem_days);
  // 	    localStorage.setItem("STB_ID", data.STB_ID);
  //       localStorage.setItem("MSO_ID",data.MSO_ID);
  //       localStorage.setItem("AddChannelFlag",data.ADD_CHANNEL);
  //       getpackdetails(
  //         data.Merchant_Salt,
  //         data.AGREEMENT_NO,
  //         data.operator_id,
  //         data.cust_num,
  //         data.MSO_ID
  //       );
  //       //getAddChannelFlag(data.operator_id);
  //     })
  //     .catch((e) => {
  //       alert("error in getting details");
  //       console.log(e);
  //       isLoading = false;
  //     });

  //     let userData1 = {
  //       CUST_NUM: decoded,
  //       FLAG: "V",
  //     };
  //     await AuthApi1.getdetail(userData1)
  //     .then((response) => {
  //       // console.log(response);
  //       let data = response.data.customerInfo;
  //       localStorage.setItem("stb_flag", data.stb_enabled);
  //       localStorage.setItem("payment_flag", data.payment_enabled);
  //     })
  //     .catch((e) => {
  //       alert("error in getting details");
  //       console.log(e);
  //       isLoading = false;
  //     });

  //   //   const stb_flag=localStorage.getItem("stb_flag");
  //   //   const payment_flag=localStorage.getItem("payment_flag");

  //   //   if (stb_flag === 'Y' && payment_flag === 'Y') {
  //   //   if (new1Date >= exDate) {
  //   //     setTotalPayFlagShow(true);
  //   //     setPaymentFlagShow(true);
  //   //     setStbFlagShow(false);
  //   //   } else {
  //   //     setStbFlagShow(true);
  //   //     setTotalPayFlagShow(false);
  //   //     setPaymentFlagShow(false);
  //   //   }
  //   // }else{
  //   //   if (stb_flag === 'Y' && payment_flag === 'N') {
  //   //     setStbFlagShow(true);
  //   //     setPaymentFlagShow(false);
  //   //     setTotalPayFlagShow(false);
  //   //   } else if (stb_flag === 'N' && payment_flag === 'Y') {
  //   //     setPaymentFlagShow(true);
  //   //     setTotalPayFlagShow(false);
  //   //     setStbFlagShow(false);
  //   //   } else {
  //   //     setStbFlagShow(false);
  //   //     setPaymentFlagShow(false);
  //   //     setTotalPayFlagShow(false);
  //   //   }
  //   // }
//custNumber
  // };

  const getDetailsCust = async () => {
    isLoading = true;

    let decoded = base64decode(custNumber);
    let decodeVc=base64decode(custV);
    console.log(decodeVc);
    let [vcNumber, operatorId] = decodeVc.split('-');
    let flag=decoded?"B":"A"
    
    // Create a URLSearchParams object from the query string
    const queryParams = new URLSearchParams(location.search);
    
    // Check if the 'custNumber' parameter exists
    const custVc = queryParams.get('custV');
    setCustV(custVc);
     if(flag==="B"){
      console.log('B blc')
      let userData = {
        CUST_NUM: decoded,
        VC_NUMBER1:decodeVc,
         flag: "A",
      };
      await AuthApi1.getdetailCust(userData)
        .then((response) => {
          let data = response.data.QRINFO;
          let newTotalAmount =
            parseFloat(data.PACK_AMOUNT) +
            parseFloat(data.DUE) +
            parseFloat(data.L_ADV_AMNT);
          let totalPay = newTotalAmount.toFixed(2);
          let totalBill = parseFloat(data.AMOUNT).toFixed(2);
          let newDateFormat = moment(data.END_DATE, "YYYY-MM-DD").format(
            "DD-MMMM-YYYY"
          );
          localStorage.setItem("custNum", data.L_CUST_NUM);
          localStorage.setItem("custID", data.L_CUST_ID);
          localStorage.setItem("phone", data.CPHONE);
          localStorage.setItem("custName", data.CNAME);
          // localStorage.setItem("email", data.EMAIL);
          localStorage.setItem("stbNumber", data.STB_NUMBER);
          localStorage.setItem("op_email", data.OEMAIL);
          localStorage.setItem("op_phone", data.SUPPORT);
          localStorage.setItem("dueAmount", totalPay);
          localStorage.setItem("bill_total", totalBill);
          localStorage.setItem("advn_dep_amnt", data.L_ADV_AMNT);
          localStorage.setItem("packTotal", data.PACK_AMOUNT);
          localStorage.setItem("cust_due", data.DUE);
          localStorage.setItem("operatorId", data.OPERATOR_ID);
          localStorage.setItem("operatorName", data.NETWORK);
          localStorage.setItem("op_address", data.OP_ADDRESS);
          localStorage.setItem("Merchant_Salt", data.SALT);
          localStorage.setItem("AGREEMENT", data.AGREEMENT);
          localStorage.setItem("PRE_END_DATE", newDateFormat);
          localStorage.setItem("rem_days", data.DAYS);
          localStorage.setItem("STB_ID", data.STB_ID);
          localStorage.setItem("MSO_ID", data.MSO);
          localStorage.setItem("AddChannelFlag", data.L_add_new_channel);
          localStorage.setItem("no_of_box", data.NO_BOX);
          localStorage.setItem("show_type", data.SHOW_TYPE);
          localStorage.setItem("can_pay", data.CAN_PAY);
          localStorage.setItem("message", data.MESSAGE);
          localStorage.setItem("merchant_id", data.MERCHANTID);
          localStorage.setItem("merchant_key", data.MKEY);
          localStorage.setItem("VC_NUMBER", data.VC_NUMBER);
          
          localStorage.setItem("direct_qr",data.direct_qr);
          getpackdetails(
            data.SALT,
            data.AGREEMENT,
            data.OPERATOR_ID,
            data.L_CUST_NUM,
            data.MSO
          );
          //getAddChannelFlag(data.operator_id);
        })
        .catch((e) => {
          alert("error in getting details");
          console.log(e);
          isLoading = false;
        });
    }
    else{
      console.log('A blc')
      let userData = {
        CUST_NUM: decoded,
        VC_NUMBER1:vcNumber,
         flag: "A",
         OPERATOR_ID:operatorId
      };
      await AuthApi1.getdetailCustByVc(userData)
        .then((response) => {
          let data = response.data.QRINFO;
          let newTotalAmount =
            parseFloat(data.PACK_AMOUNT) +
            parseFloat(data.DUE) +
            parseFloat(data.L_ADV_AMNT);
          let totalPay = newTotalAmount.toFixed(2);
          let totalBill = parseFloat(data.AMOUNT).toFixed(2);
          let newDateFormat = moment(data.END_DATE, "YYYY-MM-DD").format(
            "DD-MMMM-YYYY"
          );
          localStorage.setItem("custNum", data.L_CUST_NUM);
          localStorage.setItem("custID", data.L_CUST_ID);
          localStorage.setItem("phone", data.CPHONE);
          localStorage.setItem("custName", data.CNAME);
          // localStorage.setItem("email", data.EMAIL);
          localStorage.setItem("stbNumber", data.STB_NUMBER);
          localStorage.setItem("op_email", data.OEMAIL);
          localStorage.setItem("op_phone", data.SUPPORT);
          localStorage.setItem("dueAmount", totalPay);
          localStorage.setItem("bill_total", totalBill);
          localStorage.setItem("advn_dep_amnt", data.L_ADV_AMNT);
          localStorage.setItem("packTotal", data.PACK_AMOUNT);
          localStorage.setItem("cust_due", data.DUE);
          localStorage.setItem("operatorId", data.OPERATOR_ID);
          localStorage.setItem("operatorName", data.NETWORK);
          localStorage.setItem("op_address", data.OP_ADDRESS);
          localStorage.setItem("Merchant_Salt", data.SALT);
          localStorage.setItem("AGREEMENT", data.AGREEMENT);
          localStorage.setItem("PRE_END_DATE", newDateFormat);
          localStorage.setItem("rem_days", data.DAYS);
          localStorage.setItem("STB_ID", data.STB_ID);
          localStorage.setItem("MSO_ID", data.MSO);
          localStorage.setItem("AddChannelFlag", data.L_add_new_channel);
          localStorage.setItem("no_of_box", data.NO_BOX);
          localStorage.setItem("show_type", data.SHOW_TYPE);
          localStorage.setItem("can_pay", data.CAN_PAY);
          localStorage.setItem("message", data.MESSAGE);
          localStorage.setItem("merchant_id", data.MERCHANTID);
          localStorage.setItem("merchant_key", data.MKEY);
          localStorage.setItem("VC_NUMBER", data.VC_NUMBER);
          localStorage.setItem("direct_qr",data.direct_qr);
          getpackdetails(
            data.SALT,
            data.AGREEMENT,
            data.OPERATOR_ID,
            data.L_CUST_NUM,
            data.MSO
          );
          //getAddChannelFlag(data.operator_id);
        })
        .catch((e) => {
          alert("error in getting details");
          console.log(e);
          isLoading = false;
        });
    }
  

    const show_type = localStorage.getItem("show_type");
    const can_pay = localStorage.getItem("can_pay");
    const exp_date = localStorage.getItem("PRE_END_DATE");

    if (show_type == "RENEW") {
      setStbFlagShow(true);
      setPaymentFlagShow(false);
    } else if (show_type == "PAYMENT") {
      setStbFlagShow(false);
      setPaymentFlagShow(true);
    } else if (show_type == "BLOCK") {
      if (can_pay == "N") {
        setStbFlagShow(false);
        setPaymentFlagShow(false);
        getRenewPaymentAlert();
      }
    }

    if (show_type == "RENEW") {
      if (exp_date == null || exp_date == "Invalid date" || exp_date == "") {
        setExpiryFlagShow(false);
      } else {
        setExpiryFlagShow(true);
      }
    } else {
      setExpiryFlagShow(false);
    }
  };

  const getRenewPaymentAlert = () => {
    const dateString = localStorage.getItem("PRE_END_DATE");

    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const current1Date = new Date(currentDate);

    const a = parseInt(localStorage.getItem("rem_days"));
    const b = a - parseInt(5);
    const exDate = new Date();
    exDate.setDate(current1Date.getDate() + b);

    const day = exDate.getDate();
    const month = months[exDate.getMonth()];
    const year = exDate.getFullYear();

    const formattedDate = `${day}-${month}-${year}`;

    let msg =
      "Your Set-Top-Box can be renewed on or after " +
      formattedDate +
      ". Please come back then.";

    if (localStorage.getItem("message") == "BOX NOT FOUND / DELETED") {
      Swal.fire({
        title:
          "We couldn't find an active box under your account. Please contact your " +
          localStorage.getItem("operatorName") +
          " cable operator",
        icon: "warning",
        customClass: {
          title: "swal-custom-title",
          actions: "swal-center-button",
        },
      });
    } else if (localStorage.getItem("message") == "LESS THAN 1") {
      Swal.fire({
        title: "Amount should be greater than (\u20B9) 1.00",
        icon: "warning",
        customClass: {
          title: "swal-custom-title",
          actions: "swal-center-button",
        },
      });
    } else if (localStorage.getItem("message") == "BEFORE EXPIERY") {
      Swal.fire({
        title: msg,
        // text: msg,
        icon: "warning",
        customClass: {
          title: "swal-custom-title",
          actions: "swal-center-button",
        },
      });
    } else if (
      localStorage.getItem("message") == "MORE THAN ONE BOX TO RENEW"
    ) {
      Swal.fire({
        title: "More Than One Set-Top-Box Not Allowed To Renew!",
        icon: "warning",
        customClass: {
          title: "swal-custom-title",
          actions: "swal-center-button",
        },
      });
    } else if (localStorage.getItem("message") == "FLAG MISS MATCH") {
      Swal.fire({
        title:
          "We're sorry, but payment and renewal services are currently unavailable. For help, please reach out to your " +
          localStorage.getItem("operatorName") +
          " cable operator using the contact information provided below.",
        icon: "warning",
        html: `
          <p class="swal-custom-title"><b>Contact Number:</b> <a href="tel:${localStorage.getItem(
            "op_phone"
          )}" class="phoneMail">${localStorage.getItem("op_phone")}</a></p>
          <p class="swal-custom-title"><b>Email:</b> <a href="mailto:${localStorage.getItem(
            "op_email"
          )}" class="phoneMail">${localStorage.getItem("op_email")}</a></p>
      `,
        customClass: {
          title: "swal-custom-title",
          actions: "swal-center-button",
        },
      });
    }
  };

  const fetchAdBanner = async () => {
    isLoading = true;
    let data = {
      OP_ID: localStorage.getItem("operatorId"),
    };

    await authApi2
      .fetchAds(data)
      .then((res) => {
        //console.log(res);
        if (res.status === 200) {
          setAds(res.data.Banners);
          isLoading = false;
        }
      })
      .catch((e) => {
        console.log("Failed to fetch banner :", e);
        isLoading = false;
      });
  };

  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const amount = localStorage.getItem("dueAmount");
  const stbno =
    localStorage.getItem("stbNumber") === null ||
    localStorage.getItem("stbNumber") === "none" ||
    localStorage.getItem("stbNumber") === ""
      ? "---"
      : localStorage.getItem("stbNumber");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [payDialogOpen, setPayDialogOpen] = useState(false);
  const [payDialogOpen_NONUPI, setPayDialogOpen_NONUPI] = useState(false);
  
  const [dueDialogOpen, setDueDialogOpen] = useState(false);
  const [channelDialogOpen, setChannelDialogOpen] = useState(false);
  const [ads, setAds] = useState([]);
  const history = useHistory();
  const [button1Loading, setButton1Loading] = useState(false);
  const [button2Loading, setButton2Loading] = useState(false);
  const [button3Loading, setButton3Loading] = useState(false);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [opDialogOpen, setOpDialogOpen] = useState(false);
  const [stbFlagShow, setStbFlagShow] = useState(false);
  const [paymentFlagShow, setPaymentFlagShow] = useState(false);
  const [expiryFlagShow, setExpiryFlagShow] = useState(false);

  
  const onSignIn = async () => {
    setButtonLoading(true);

    if (localStorage.getItem("can_pay") == "N") {
      setButtonLoading(false);
      getRenewPaymentAlert();
    } else {
      setPayDialogOpen_NONUPI(true);
    }
  };

  const newSign = async () => {
    let newDate = new Date();
    let getYear = newDate.getFullYear().toString();
    let getMonth = newDate.getMonth().toString();
    let getDate = newDate.getDate().toString();
    let getMSec = newDate.getMilliseconds().toString();
    let combineDate = getYear + getMonth + getDate + getMSec;
    
    let tranRef = custVc?"TVQI" + localStorage.getItem("custNum") + combineDate:"DISPT" + localStorage.getItem("custNum") + combineDate; //
 
    // let tran =
    //   "TRNNXTSUBWEB" + parseInt(localStorage.getItem("ownerId")) + Date.now();
    let data = JSON.stringify({
      AMOUNT: localStorage.getItem("dueAmount"),
      PHONE: localStorage.getItem("phone"),
      OPERATOR_ID: localStorage.getItem("operatorId"),
      flag: "C",
      CUST_NUM: localStorage.getItem("custNum"),
      CUST_NAME: localStorage.getItem("custName"),
      tran_id: tranRef,
    });
    await AuthApi.cashfree_init(data)
      .then((response) => {
        console.log(response);
        if (response.data.p_out_mssg_flg === "S") {
          window.location.href =
            "https://apps.mobiezy.in/CASHFREE/INTEGRATED/cashfree_ui.php?paymentSessionId=" +
            response.data.payment_session_id;
        } else {
          setButtonLoading(false);
          swal("Error", response.data.p_out_mssg, "warning");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const onSignIn_UPI = async (ptype) => {
    localStorage.setItem("ptype",ptype);
    setButtonLoading(true);

    if (localStorage.getItem("can_pay") == "N") {
      setButtonLoading(false);
      getRenewPaymentAlert();
    } else {
      setPayDialogOpen(true);
    }
  };

  const newSign_UPI = async () => {
    let ptype= localStorage.getItem("ptype");
    let newDate = new Date();
    let getYear = newDate.getFullYear().toString();
    let getMonth = newDate.getMonth().toString();
    let getDate = newDate.getDate().toString();
    let getMSec = newDate.getMilliseconds().toString();
    let combineDate = getYear + getMonth + getDate + getMSec;

    let tranRef = custVc?"TVQI" + localStorage.getItem("custNum") + combineDate:"DISPT" + localStorage.getItem("custNum") + combineDate; //
 
    // let tran =
    //   "TRNNXTSUBWEB" + parseInt(localStorage.getItem("ownerId")) + Date.now();
    let data = JSON.stringify({
      AMOUNT: localStorage.getItem("dueAmount"),
      PHONE: localStorage.getItem("phone"),
      OPERATOR_ID: localStorage.getItem("operatorId"),
      flag: "C",
      CUST_NUM: localStorage.getItem("custNum"),
      CUST_NAME: localStorage.getItem("custName"),
      tran_id: tranRef,
    });
    await AuthApi.cashfree_init(data)
      .then((response) => {
        console.log(response);
        if (response.data.p_out_mssg_flg === "S") {
        /*  window.location.href =
            "https://apps.mobiezy.in/CASHFREE/INTEGRATED/cashfree_ui.php?paymentSessionId=" +
            response.data.payment_session_id;*/
            let data = JSON.stringify({
              id: response.data.payment_session_id,
              upi_type: ptype
            });
              AuthApi.cashfree_init_upi_link(data)
            .then((response) => {
              console.log(response.data);
              console.log(response.data[ptype]);
              try {
                if (response.data[ptype]) {
                  // Try redirecting to the UPI URL
                  setButtonLoading(false);
                  try{
                    window.location.href = response.data[ptype];
                    setTimeout(function() {
                      // Provide fallback in case the URL scheme does not work
                    // alert('Something Went Wrong')
                    window.location.href = response.data.web
                  }, 1500); 
                  }
                  catch(e){
                    console.log('error');
                  }
             } else {
                  throw new Error("UPI link not available");
                }
              } catch (e) {
				  alert('Something Went Wrong')
                console.error("Error during UPI redirect:", e);
                console.log("Failed to initiate payment. A user gesture is required to proceed.");
              }
            })
            .catch((e) => {
              setButtonLoading(false);
              console.log(e);
            });
        } else {
          setButtonLoading(false);
          swal("Error", response.data.p_out_mssg, "warning");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

 

  const handleDialogOp = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handlePayDialogOp = () => {
    onSignIn();
  };
  const handlePayDialogOp_UPI = (ptype) => {
    onSignIn_UPI(ptype);
  };

  const handleOpDialogOpen = () => {
    setOpDialogOpen(true);
  };
  
  const history1 = useHistory();
 const handlelogout = () => {
    localStorage.removeItem("custNumber");
    localStorage.clear();
  
    // Use history.push to redirect to the home page ("/")
   
    history1.push("/");  // Redirect to the homepage
     
  };
  const handleOpDialogClose = () => {
    setOpDialogOpen(false);
  };

  const handleDueDialogOp = async () => {
    setDueDialogOpen(true);
    const amount = localStorage.getItem("bill_total");
    console.log("Due Cleared", localStorage.getItem("custNum"));
    //  alert(localStorage.getItem("ownerId"));
    setButtonLoading(true);
    // isButtonLoading(true);

    if (localStorage.getItem("can_pay") == "N") {
      setButtonLoading(false);
      getRenewPaymentAlert();
    } else {
      setButtonLoading(true);
      // isButtonLoading=true;
      let newDate = new Date();
      let getYear = newDate.getFullYear().toString();
      let getMonth = newDate.getMonth().toString();
      let getDate = newDate.getDate().toString();
      let getMSec = newDate.getMilliseconds().toString();
      let combineDate = getYear + getMonth + getDate + getMSec;
 
      let tranRef = custVc?"TVQ" + localStorage.getItem("custNum") + combineDate:"DSPT" + localStorage.getItem("custNum") + combineDate; //
 
      console.log(tranRef);
      // let tran =
      //   "TRNNXTSUBWEB" + parseInt(localStorage.getItem("ownerId")) + Date.now();
      let data = JSON.stringify({
        AMOUNT: localStorage.getItem("bill_total"),
        PHONE: localStorage.getItem("phone"),
        OPERATOR_ID: localStorage.getItem("operatorId"),
        flag: "A",
        CUST_NUM: localStorage.getItem("custNum"),
        customerName: localStorage.getItem("custName"),
        tran_id: tranRef,
      });
      console.log(data);
      await AuthApi.cashfree_init_payment(data)
        .then((response) => {
          console.log(response);
          if (response.data.p_out_mssg_flg === "S") {
            window.location.href =
              "https://apps.mobiezy.in/CASHFREE/QR_PAY/cashfree_ui.php?paymentSessionId=" +
              response.data.payment_session_id;
          } else {
            setButtonLoading(false);
            swal("Error", response.data.p_out_mssg, "warning");
          }
        })
        .catch((e) => {
          setButtonLoading(false);
          console.log(e);
        });
    }
  };


  const handleDueDialogOp_UPI = async (ptype) => {
  //  console.log(ptype);
    setDueDialogOpen(true);
    const amount = localStorage.getItem("bill_total");
    console.log("Due Cleared", localStorage.getItem("custNum"));
    //  alert(localStorage.getItem("ownerId"));
    setButtonLoading(true);
    // isButtonLoading(true);

    if (localStorage.getItem("can_pay") == "N") {
      setButtonLoading(false);
      getRenewPaymentAlert();
    } else {
      setButtonLoading(true);
      // isButtonLoading=true;
      let newDate = new Date();
      let getYear = newDate.getFullYear().toString();
      let getMonth = newDate.getMonth().toString();
      let getDate = newDate.getDate().toString();
      let getMSec = newDate.getMilliseconds().toString();
      let combineDate = getYear + getMonth + getDate + getMSec;

      let tranRef = custVc?"TVQ" + localStorage.getItem("custNum") + combineDate:"DSPT" + localStorage.getItem("custNum") + combineDate; //
 
      console.log(tranRef);
      // let tran =
      //   "TRNNXTSUBWEB" + parseInt(localStorage.getItem("ownerId")) + Date.now();
      let data = JSON.stringify({
        AMOUNT: localStorage.getItem("bill_total"),
        PHONE: localStorage.getItem("phone"),
        OPERATOR_ID: localStorage.getItem("operatorId"),
        flag: "A",
        CUST_NUM: localStorage.getItem("custNum"),
        customerName: localStorage.getItem("custName"),
        tran_id: tranRef,
      });
      console.log(data);
      await AuthApi.cashfree_init_payment(data)
        .then((response) => {
          console.log(response);
          if (response.data.p_out_mssg_flg === "S") {
       /*     window.location.href =
              "https://apps.mobiezy.in/CASHFREE/QR_PAY/cashfree_ui.php?paymentSessionId=" +
              response.data.payment_session_id;*/

              let data = JSON.stringify({
                id: response.data.payment_session_id,
                upi_type: ptype
              });
                AuthApi.cashfree_init_upi_link(data)
              .then((response) => {
                console.log(response.data);
                console.log(response.data[ptype]);
                try {
                  if (response.data[ptype]) {
                    // Try redirecting to the UPI URL
                    setButtonLoading(false);
                    try{
                      window.location.href = response.data[ptype];
                      setTimeout(function() {
                        // Provide fallback in case the URL scheme does not work
                      // alert('Something Went Wrong')
                       window.location.href = response.data.web
                    }, 1500); 
                    }
                    catch(e){
                      console.log('error');
                    }
               } else {
                    throw new Error("UPI link not available");
                  }
                } catch (e) {
                  console.error("Error during UPI redirect:", e);
                  console.log("Failed to initiate payment. A user gesture is required to proceed.");
                }
              })
              .catch((e) => {
                setButtonLoading(false);
                console.log(e);
              });
          } else {
            setButtonLoading(false);
            swal("Error", response.data.p_out_mssg, "warning");
          }
        })
        .catch((e) => {
          setButtonLoading(false);
          console.log(e);
        });
    }
  };
  const handlePayDialogClose_CFMODE=()=>{
	  console.log('closed clicked');
      setPayDialogOpen_NONUPI(false);
      newSign();
  }
  const handlePayDialogClose = () => {
    // onSignIn();
   /* if(localStorage.getItem("direct_qr")==="Y"){
      newSign_UPI();
      setPayDialogOpen(false);
    }
    else{
      newSign();
      setPayDialogOpen(false);
    }*/
	 newSign_UPI();
      setPayDialogOpen(false);
   
  };

  const handleCancelDialogClose = () => {
    setPayDialogOpen(false);
    setButtonLoading(false);
  };
    const handleCancelDialogClose_CF_MODE = () => {
    setPayDialogOpen_NONUPI(false);
    setButtonLoading(false);
  };

  const handleChannelDialogClose = () => {
    setChannelDialogOpen(false);
    setButton1Loading(false);
  };

  const redirect_url = (url) => {
    // window.location.href = url;
    console.log("Redirection URL:", url);

    if (url != null) {
      window.open(url);
    }
  };

  const dateString = localStorage.getItem("PRE_END_DATE");
  const dueAmount = parseFloat(localStorage.getItem("dueAmount"));

  const expDate = new Date(dateString);

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const day = expDate.getDate();
  const month = months[expDate.getMonth()];
  const year = expDate.getFullYear();

  const formattedDate = `${day}-${month}-${year}`;

  console.log(formattedDate);

  const current1Date = new Date(currentDate);

  const exDate = new Date();
  exDate.setDate(current1Date.getDate() + 15);

  // const new1Date = new Date(expDate);
  const new1Date = new Date(localStorage.getItem("PRE_END_DATE"));
  // console.log(current1Date,exDate,new1Date,dueAmount,localStorage.getItem("cust_due"));

  const a1 = parseInt(localStorage.getItem("rem_days"));
  const b1 = a1 - parseInt(5);
  const remDate = new Date();
  remDate.setDate(current1Date.getDate() + b1);

  const dayRem = remDate.getDate();
  const monthRem = months[remDate.getMonth()];
  const yearRem = remDate.getFullYear();

  const formattedRemDate = `${dayRem}-${monthRem}-${yearRem}`;

  let msg = "Your Set-Top-Box can be renewed on or after " + formattedRemDate;

  // console.log(current1Date,exDate,new1Date,dueAmount,stb_flag,payment_flag);

  // --------------------------------Old Fetch Add Function---------------------------------------------
  // const renderAdsBanners = (ads) => {
  //   return ads.map((number, index) =>
  //       <div style={{backgroundColor: "#151719",cursor: "pointer"}} >
  //         {/* <img key={index} src={number.LINK} alt="ADS Banner" onClick={() => redirect_url(number.REDIRECT !== null? number.REDIRECT:"")} /> */}
  //         <img key={index} src={number.LINK} alt="ADS Banner" onClick={() => redirect_url(number.REDIRECT)} />
  //       </div>
  //   );
  // }

  const renderAdsBanners = (ads) => {
    return ads.map((number, index) => (
      <div style={{ backgroundColor: "#151719", cursor: "pointer" }}>
        <img
          key={index}
          src={number.LINK}
          alt="ADS Banner"
          onClick={() => redirect_url(number.REDIRECT)}
        />
      </div>
    ));
  };

  return isLoading === true ? (
    <center>
      <section {...props} className={outerClasses}>
        <div className="container-sm">
          <div className="hero-content">
            <div style={{ marginTop: "120px" }}>
              <Loader
                type="box-rectangular"
                bgColor={"#FFA500"}
                color={"#FFA500"}
                size={80}
              />
            </div>
          </div>
        </div>
      </section>
    </center>
  ) : (
    <>
      <Header title={"Hero"}  onlogoutBtnClick={handlelogout} onContactBtnClick={handleOpDialogOpen} />
      <center>
        <section {...props} className={outerClasses}>
          <div className="container-sm">
            <hr></hr>
            <div className="container-xs" style={{ marginTop: "40px" }}>
              <AutoplaySlider
                // renderPagination={() => null}
                // dotStyle={{
                //   display: "none",
                // }}
                play={true}
                cancelOnInteraction={true} // should stop playing on user interaction
                interval={5000}
              >
                {/* {renderAdsBanners(ads)} */}
                {ads && ads.length > 0 ? (
                  renderAdsBanners(ads)
                ) : (
                  <div
                    style={{ backgroundColor: "#151719", cursor: "pointer" }}
                  >
                    <img
                      src="https://banners-cableguy.s3.us-west-2.amazonaws.com/payment.png"
                      alt="ADS Banner"
                      onClick={() => redirect_url(null)}
                    />
                  </div>
                )}
              </AutoplaySlider>{" "}
            </div>
            {/**/}
            {/* <div data-src={require("../../assets/images/covid.png")} /> */}
            {/* <div data-src={require("../../assets/images/payment.png")} /> */}
            {/* <div data-src="https://i.picsum.photos/id/46/200/300.jpg?hmac=hO6W_-hkJCRf3aWSzs0SkaWPFlMhZsixxrObPW_sFaY" /> */}
            <hr></hr>
            <div style={{ textAlign: "center", fontWeight: "700" }}>
              <h3 style={{ color: "#1CB68B" }}>
                {localStorage.getItem("operatorName")}
              </h3>
            </div>

            {localStorage.getItem("message") === "BEFORE EXPIERY" ? (
              <div className="MoveText">
                <div className="moving-text">
                  <h5 style={{ color: "orange" }}>{msg}</h5>
                </div>
              </div>
            ) : null}

            <div
              className="hero-content"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  gap: "15px",
                  // border: '2px solid orange',
                  // borderRadius: '15px',
                  // padding: '20px'
                }}
              >
                <Typography variant={isSmallScreen ? "button" : "h6"}>
                  <FontAwesomeIcon icon={faCircleUser} color="orange" />
                  &nbsp;{" "}
                  <span className="text-color-primary">
                    {" "}
                    Name
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:{" "}
                  </span>
                  <span className="text-color-light">
                    {localStorage.getItem("custName")}
                  </span>
                </Typography>

                <Typography variant={isSmallScreen ? "button" : "h6"}>
                  <FontAwesomeIcon icon={faDisplay} color="orange" />{" "}
                  {localStorage.getItem("MSO_ID") === "14" ? (
                    <>
                      <span className="text-color-primary">
                        VC Number
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;
                      </span>
                      <span className="text-color-light">
                        {localStorage.getItem("VC_NUMBER")}
                      </span>
                    </>
                  ) : (
                    <>
                      <span className="text-color-primary">
                        STB Number &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;
                      </span>
                      <span className="text-color-light">{stbno}</span>
                    </>
                  )}
                </Typography>
                {expiryFlagShow ? (
                  <Typography variant={isSmallScreen ? "button" : "h6"}>
                    <FontAwesomeIcon icon={faCalendarDay} color="orange" />
                    &nbsp;{" "}
                    <span className="text-color-primary">
                      {" "}
                      {"  "}Expiry Date
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;
                    </span>
                    <span className="text-color-light">
                      {localStorage.getItem("PRE_END_DATE")}
                    </span>
                  </Typography>
                ) : (
                  ""
                )}

                {paymentFlagShow ? (
                  <Typography variant={isSmallScreen ? "button" : "h6"}>
                    <FontAwesomeIcon icon={faReceipt} color="orange" />
                    &nbsp;
                    <span className="text-color-primary">
                      {" "}
                      Payable Amount :{" "}
                    </span>
                    <span className="text-color-light">
                      {"\u20B9"} {localStorage.getItem("bill_total")}
                    </span>
                    {/* <FontAwesomeIcon style={{marginLeft: '10px', width: '15px', height: '15px'}} icon={faCircleInfo} color="aqua" onClick={() => handleDialogOp()}/> */}
                  </Typography>
                ) : null}
                {stbFlagShow ? (
                  <Typography variant={isSmallScreen ? "button" : "h6"}>
                    <FontAwesomeIcon icon={faReceipt} color="orange" />
                    &nbsp;
                    <span className="text-color-primary">
                      {" "}
                      Payable Amount :{" "}
                    </span>
                    <span className="text-color-light">
                      {"\u20B9"} {localStorage.getItem("dueAmount")}
                    </span>
                    {localStorage.getItem("MSO_ID") === "12" ? (
                      ""
                    ) : (
                      <FontAwesomeIcon
                        style={{
                          marginLeft: "10px",
                          width: "15px",
                          height: "15px",
                        }}
                        icon={faCircleInfo}
                        color="aqua"
                        onClick={() => handleDialogOp()}
                      />
                    )}
                  </Typography>
                ) : null}

              </div>
			  	<div className="container-sm" style={{ marginTop: "20px" }}>
   {paymentFlagShow ? (
        !isButtonLoading ? (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between", // Better spacing between buttons
          marginTop: "15px",
        }}
      >
        {/* First Set of Buttons */}
        <Button
          style={{
            width: "30%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px",
            backgroundColor: "transparent",
            flexDirection: "column", // Allow image and text to stack vertically
          }}
          tag="a"
          color="primary"
          wideMobile
          onClick={() => handleDueDialogOp_UPI("gpay")}
        >
          <img
            src={gpayLogo}
            alt="GPay"
            style={{
              height: "70px",
              width: "70px",
              borderRadius: "20px",
              objectFit: "cover",
              marginBottom: "5px",
            }}
          />
          <span style={{ fontSize: "14px", color: "#fff" }}>GPay</span>
        </Button>

        <Button
          style={{
            width: "30%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px",
            backgroundColor: "transparent",
            flexDirection: "column",
          }}
          tag="a"
          color="primary"
          wideMobile
          onClick={() => handleDueDialogOp_UPI("phonepe")}
        >
          <img
            src={phone_payLogo}
            alt="PhonePe"
            style={{
              height: "70px",
              width: "70px",
              borderRadius: "20px",
              objectFit: "cover",
              marginBottom: "5px",
            }}
          />
          <span style={{ fontSize: "14px", color: "#fff" }}>PhonePe</span>
        </Button>

        <Button
          style={{
            width: "30%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px",
            backgroundColor: "transparent",
            flexDirection: "column",
          }}
          tag="a"
          color="primary"
          wideMobile
          onClick={() => handleDueDialogOp_UPI("default")}
        >
          <img
            src={anyUPILogo}
            alt="Any UPI"
            style={{
              height: "70px",
              width: "70px",
              borderRadius: "20px",
              objectFit: "cover",
              marginBottom: "5px",
            }}
          />
          <span style={{ fontSize: "14px", color: "#fff" }}>Any UPI</span>
        </Button>
      </div>
      
      <div
        style={{
          display: "flex",
          justifyContent: "space-between", // Better spacing between buttons
          marginTop: "60px",
        }}
      >
        <Button
          style={{
               width: "30%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px",
            
			marginTop: "10px",
            backgroundColor: "transparent",
            flexDirection: "column",
          }}
          tag="a"
          color="primary"
          wideMobile
          onClick={() => handleDueDialogOp()}
        >
          <img
            src={ot_logo}
            alt="Any Mode"
            style={{
                height: "70px",
              width: "70px",
              borderRadius: "20px",
              objectFit: "cover",
              marginBottom: "5px",
            }}
          />
          <span style={{ fontSize: "14px", color: "#fff" }}>Cards</span>
        </Button>

        <Button
          style={{
            width: "30%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px",
			marginTop: "10px",
            backgroundColor: "transparent",
            flexDirection: "column",
          }}
          tag="a"
          color="primary"
          wideMobile
          onClick={() => history.push("/AddComplaints")}
        >
          <img
            src={comp_logo}
            alt="Complaints"
            style={{
              height: "70px",
              width: "70px",
              borderRadius: "20px",
              objectFit: "cover",
              marginBottom: "5px",
            }}
          />
          <span style={{ fontSize: "14px", color: "#fff" }}>Complaints</span>
        </Button>

        <Button
          style={{
            width: "30%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px",
            backgroundColor: "transparent",
			marginTop: "10px",
            flexDirection: "column",
          }}
          tag="a"
          color="primary"
          wideMobile
          onClick={() => history.push("/Transactions")}
        >
          <img
            src={tran_logo}
            alt="Transactions"
            style={{
              height: "70px",
              width: "70px",
              borderRadius: "20px",
              objectFit: "cover",
              marginBottom: "5px",
            }}
          />
          <span style={{ fontSize: "14px", color: "#fff" }}>Transactions</span>
        </Button>
      </div>
    </>
  )  : (
          <center style={{ width: "100%" }}>
            <div className="hero-content">
              <div style={{ marginTop: "5px" }}>
                <Loader
                  type="box-rectangular"
                  bgColor={"#FFA500"}
                  color={"#FFA500"}
                  size={isSmallScreen ? 60 : 80}
                />
              </div>
            </div>
          </center>
        )
      ) : (
    ""
      )}
</div>

 {stbFlagShow && !isButtonLoading ? (
  <>
    <div className="container-sm">
      {/* First row of buttons */}
     <div
  style={{
    display: "flex",
    justifyContent: "SPACE-AROUND", // Distribute buttons evenly across the row
    marginTop: "15px",
	marginLeft:localStorage.getItem("AddChannelFlag") === "Y" ? "10px" : "0px",
  }}
>
  {/* GPay Button */}
  <Button
    style={{
      width: "23%", // Adjust width to make sure all buttons fit in the same row
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "10px",
      backgroundColor: "transparent",
      flexDirection: "column",
      marginBottom: "10px",
    }}
    tag="a"
    wideMobile
    onClick={() => handlePayDialogOp_UPI("gpay")}
  >
    <img
      src={gpayLogo}
      alt="GPay"
      style={{
        height: "70px",
        width: "70px",
        borderRadius: "20px",
        objectFit: "cover",
        marginBottom: "5px",
      }}
    />
    <span style={{ fontSize: "14px", color: "#fff" }}>GPay</span>
  </Button>

  {/* PhonePe Button */}
  <Button
    style={{
      width: "23%", // Adjust width to make sure all buttons fit in the same row
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "10px",
      backgroundColor: "transparent",
      flexDirection: "column",
      marginBottom: "10px",
    }}
    tag="a"
    color="primary"
    wideMobile
    onClick={() => handlePayDialogOp_UPI("phonepe")}
  >
    <img
      src={phone_payLogo}
      alt="PhonePe"
      style={{
        height: "70px",
        width: "70px",
        borderRadius: "20px",
        objectFit: "cover",
        marginBottom: "5px",
      }}
    />
    <span style={{ fontSize: "14px", color: "#fff" }}>PhonePe</span>
  </Button>

  {/* Any UPI Button */}
  <Button
    style={{
      width: "23%", // Adjust width to make sure all buttons fit in the same row
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "10px",
      backgroundColor: "transparent",
      flexDirection: "column",
      marginBottom: "10px",
    }}
    tag="a"
    color="primary"
    wideMobile
    onClick={() => handlePayDialogOp_UPI("default")}
  >
    <img
      src={anyUPILogo}
      alt="Any UPI"
      style={{
        height: "70px",
        width: "70px",
        borderRadius: "20px",
        objectFit: "cover",
        marginBottom: "5px",
      }}
    />
    <span style={{ fontSize: "14px", color: "#fff" }}>Any UPI</span>
  </Button>

  {/* Other Payment Mode Button (conditionally rendered) */}
  {localStorage.getItem("AddChannelFlag") === "Y" && (
    <Button
      style={{
        width: "23%", // Adjust width to make sure all buttons fit in the same row
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "10px",
        backgroundColor: "transparent",
        flexDirection: "column",
        marginBottom: "10px",
      }}
      tag="a"
      color="primary"
      wideMobile
      onClick={() => handlePayDialogOp()}
    >
      <img
        src={ot_logo}
        alt="Any UPI"
        style={{
          height: "70px",
          width: "70px",
          borderRadius: "20px",
          objectFit: "cover",
          marginBottom: "5px",
        }}
      />
      <span style={{ fontSize: "14px", color: "#fff" }}>Cards</span>
    </Button>
  )}
</div>

  <div
  style={{
    display: "flex",
    justifyContent: "SPACE-AROUND", // Distribute buttons evenly across the row
    marginTop: "60px",
	marginLeft:localStorage.getItem("AddChannelFlag") === "Y" ? "10px" : "0px",
  }}
>
  {/* GPay Button */}
    {localStorage.getItem("AddChannelFlag") === "N" ? (
  <Button
    style={{
      width: "23%", // Adjust width to make sure all buttons fit in the same row
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "10px",
      backgroundColor: "transparent",
      flexDirection: "column",
      marginBottom: "10px",
    }}
    tag="a"
    wideMobile
    onClick={() => handlePayDialogOp()}
  >
    <img
      src={ot_logo}
      alt="GPay"
      style={{
        height: "70px",
        width: "70px",
        borderRadius: "20px",
        objectFit: "cover",
        marginBottom: "5px",
      }}
    />
    <span style={{ fontSize: "14px", color: "#fff" }}>Cards</span>
  </Button>
) : localStorage.getItem("AddChannelFlag") === "Y" ? (
  <Button
    style={{
      width: "23%", // Adjust width to make sure all buttons fit in the same row
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "10px",
      backgroundColor: "transparent",
      flexDirection: "column",
      marginBottom: "10px",
    }}
    tag="a"
    wideMobile
   onClick={() => {
    history.push("/AddChannel"); // Redirect to AddChannel page
  }}
  >
    <img
      src={addch_logo}
      alt="add channel"
      style={{
        height: "70px",
        width: "70px",
        borderRadius: "20px",
        objectFit: "cover",
        marginBottom: "5px",
      }}
    />
    <span style={{ fontSize: "14px", color: "#fff" }}>Add Channel</span>
  </Button>
  ) : null}
  
  {/* PhonePe Button */}
  <Button
    style={{
      width: "23%", // Adjust width to make sure all buttons fit in the same row
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "10px",
      backgroundColor: "transparent",
      flexDirection: "column",
      marginBottom: "10px",
    }}
    tag="a"
    color="primary"
    wideMobile
          onClick={() => history.push("/AddComplaints")}
    
  >
    <img
      src={comp_logo}
      alt="PhonePe"
      style={{
        height: "70px",
        width: "70px",
        borderRadius: "20px",
        objectFit: "cover",
        marginBottom: "5px",
      }}
    />
    <span style={{ fontSize: "14px", color: "#fff" }}>Complaints</span>
  </Button>

  {/* Any UPI Button */}
  <Button
    style={{
      width: "23%", // Adjust width to make sure all buttons fit in the same row
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "10px",
      backgroundColor: "transparent",
      flexDirection: "column",
      marginBottom: "10px",
    }}
    tag="a"
    color="primary"
    wideMobile
         onClick={() => history.push("/Transactions")}
     
  >
    <img
      src={tran_logo}
      alt="Any UPI"
      style={{
        height: "70px",
        width: "70px",
        borderRadius: "20px",
        objectFit: "cover",
        marginBottom: "5px",
      }}
    />
    <span style={{ fontSize: "14px", color: "#fff" }}>Transactions</span>
  </Button>

  {/* Other Payment Mode Button (conditionally rendered) */}
  {localStorage.getItem("AddChannelFlag") === "Y" && (
    <Button
      style={{
        width: "23%", // Adjust width to make sure all buttons fit in the same row
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "10px",
        backgroundColor: "transparent",
        flexDirection: "column",
        marginBottom: "10px",
		"visibility": "collapse",
      }}
      tag="a"
      color="primary"
      wideMobile 
    >
      <img
        src={ot_logo}
        alt="Any UPI"
        style={{
          height: "70px",
          width: "70px",
          borderRadius: "20px",
          objectFit: "cover",
          marginBottom: "5px",
        }}
      />
      <span style={{ fontSize: "14px", color: "#fff" }}>Cards</span>
    </Button>
  )}
</div> 
    </div>
  </>
) : stbFlagShow && isButtonLoading ? (
  <center style={{ width: "100%" }}>
    <div className="container-sm">
      <div className="hero-content">
        <div style={{ marginTop: "5px" }}>
          <Loader
            type="box-rectangular"
            bgColor={"#FFA500"}
            color={"#FFA500"}
            size={isSmallScreen ? 60 : 80}
          />
        </div>
      </div>
    </div>
  </center>
) : null} 
                 
            </div>
            <p></p>
          </div>
          {/*---------------- The following dialog is to show amount break-up ----------------*/}
          <Dialog open={dialogOpen}>
            <DialogTitle>
              <Typography color={"black"}>Amount Break-Up</Typography>
            </DialogTitle>
            <DialogContent>
              <Typography>
                <table>
                  <tr>
                    <td>Pack Price</td>
                    <td>:</td>
                    <td>₹{localStorage.getItem("packTotal")}</td>
                  </tr>
                  <tr>
                    <td>Due</td>
                    <td>:</td>
                    <td>₹{localStorage.getItem("cust_due")}</td>
                  </tr>
                  <tr>
                    <td>Adjustments</td>
                    <td>:</td>
                    <td>₹{localStorage.getItem("advn_dep_amnt")}</td>
                  </tr>
                  <tr>
                    <td>Total Payable</td>
                    <td>:</td>
                    <td>₹{localStorage.getItem("dueAmount")}</td>
                  </tr>
                </table>
              </Typography>
              <DialogActions>
                <Button
                  style={{
                    width: "100%",
                    backgroundColor: "#1CB68B",
                    color: "white",
                    border: "0px solid green",
                    borderRadius: "15px",
                  }}
                  onClick={() => {
                    handleDialogClose();
                  }}
                  onClose={() => {
                    handleDialogClose();
                  }}
                >
                  Close
                </Button>
              </DialogActions>
            </DialogContent>
          </Dialog>
          {/*---------------- The following dialog is to tell customer to turn-on their STB ----------------*/}
          <Dialog open={payDialogOpen_NONUPI}>
            <DialogTitle>
              <Typography color={"black"}>Attention!!</Typography>
            </DialogTitle>
            <DialogContent>
              <Typography>
                Please make sure your Set-Top-Box is turned on before payment.
              </Typography>
              <DialogActions>
                <Button
                  style={{
                    width: "100%",
                    backgroundColor: "white",
                    color: "#1CB68B",
                    border: "2px solid #1CB68B",
                    borderRadius: "15px",
                  }}
                  onClick={() => {
                    handleCancelDialogClose_CF_MODE();
                  }}
                  onClose={() => {
                    handleCancelDialogClose_CF_MODE();
                  }}
                >
                  Cancel
                </Button>
                <Button
                  style={{
                    width: "100%",
                    backgroundColor: "#1CB68B",
                    color: "white",
                    border: "0px solid green",
                    borderRadius: "15px",
                  }}
                  onClick={() => {
                    handlePayDialogClose_CFMODE();
                  }}
                  onClose={() => {
                    handlePayDialogClose_CFMODE();
                  }}
                >
                  Proceed
                </Button>
              </DialogActions>
            </DialogContent>
          </Dialog>
		   {/*---------------- The following dialog is to tell customer to turn-on their STB ON UPI PAYMENT ----------------*/}
          <Dialog open={payDialogOpen}>
            <DialogTitle>
              <Typography color={"black"}>Attention!!</Typography>
            </DialogTitle>
            <DialogContent>
              <Typography>
                Please make sure your Set-Top-Box is turned on before payment.
              </Typography>
              <DialogActions>
                <Button
                  style={{
                    width: "100%",
                    backgroundColor: "white",
                    color: "#1CB68B",
                    border: "2px solid #1CB68B",
                    borderRadius: "15px",
                  }}
                  onClick={() => {
                    handleCancelDialogClose();
                  }}
                  onClose={() => {
                    handleCancelDialogClose();
                  }}
                >
                  Cancel
                </Button>
                <Button
                  style={{
                    width: "100%",
                    backgroundColor: "#1CB68B",
                    color: "white",
                    border: "0px solid green",
                    borderRadius: "15px",
                  }}
                  onClick={() => {
                    handlePayDialogClose();
                  }}
                  onClose={() => {
                    handlePayDialogClose();
                  }}
                >
                  Proceed
                </Button>
              </DialogActions>
            </DialogContent>
          </Dialog>
          {/*---------------- The following dialog is to inform user that this particular feature is not available for them. ----------------*/}
          <Dialog open={channelDialogOpen}>
            <DialogTitle>
              <Typography color={"black"}>Oops! Feature Unavailable</Typography>
            </DialogTitle>
            <DialogContent>
              <Typography>
                This feature is not yet available for you.
              </Typography>
              <DialogActions>
                <Button
                  style={{
                    width: "100%",
                    backgroundColor: "#1CB68B",
                    color: "white",
                    border: "0px solid green",
                    borderRadius: "15px",
                  }}
                  onClick={() => {
                    handleChannelDialogClose();
                  }}
                  onClose={() => {
                    handleChannelDialogClose();
                  }}
                >
                  OK
                </Button>
              </DialogActions>
            </DialogContent>
          </Dialog>
          <Dialog open={opDialogOpen}>
            <DialogTitle>
              <Typography variant="h6" color={"black"} align="center">
                Contact Info
              </Typography>
            </DialogTitle>
            <DialogContent align="left">
              <DialogContentText>
                Network Name:&nbsp;
                <span style={{ color: "#9CA9B3" }}>
                  {localStorage.getItem("operatorName")}
                </span>
              </DialogContentText>
              <DialogContentText>
                Phone&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;
                {localStorage.getItem("op_phone") ? (
                  <a
                    href={`tel:${localStorage.getItem("op_phone")}`}
                    style={{ color: "#9CA9B3" }}
                  >
                    {localStorage.getItem("op_phone")}
                  </a>
                ) : (
                  ""
                )}
              </DialogContentText>
              <DialogContentText>
                Email&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;
                {localStorage.getItem("op_email") ? (
                  <a
                    href={`mailto:${localStorage.getItem("op_email")}`}
                    style={{ color: "#9CA9B3" }}
                  >
                    {localStorage.getItem("op_email")}
                  </a>
                ) : (
                  ""
                )}
              </DialogContentText>
              <DialogContentText>
                <div
                  style={{
                    display: "flex",
                    alignItems: "right",
                    width: "100%",
                  }}
                >
                  <span style={{ marginRight: "5px", whiteSpace: "nowrap" }}>
                    Address&nbsp;:
                  </span>
                  <div style={{ flexGrow: 1, color: "#9CA9B3" }}>
                    {localStorage.getItem("op_address")}
                  </div>
                </div>
              </DialogContentText>
              <DialogActions>
                <Button
                  style={{
                    width: "100%",
                    backgroundColor: "#1CB68B",
                    color: "white",
                    border: "0px solid green",
                    borderRadius: "15px",
                  }}
                  onClick={() => {
                    handleOpDialogClose();
                  }}
                  onClose={() => {
                    handleOpDialogClose();
                  }}
                >
                  Close
                </Button>
              </DialogActions>
            </DialogContent>
          </Dialog>
        </section>
      </center>
    </>
  );
};

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;
